<template>
  <div class="date-wrap">
    <div :class="[dataCore.length <= 5 ? 'box-card-list' : 'box-card-list-l']">
      <div class="box-card-item" v-for="(item, index) in dataCore" :key="index">
        <span class="box-card-item-title">{{ item.title }}</span>
        <div class="box-card-item-num">
          <div class="box-card-icon" :style="{ background: item.bgColor ? item.bgColor : '#FF9F19' }">
            <svg class="icon svg-icon schedule-roll-close" aria-hidden="true" style="width: 18px;height: 18px;">
              <use :xlink:href="item.icon ? item.icon : '#icon-xiansuoshu'"></use>
            </svg>
          </div>
          <span class="box-card-item-max">{{ item.title && item.title.indexOf('率') != -1 ? item.count + '%' : item.count }}</span>
        </div>
 
        <div class="box-card-progress" >
          <el-progress
            class="chart-bom-bom-pro1"
            :stroke-width="8"
            :percentage="Number(item.title && item.title.indexOf('率') != -1 ? item.count : '70')"
            :class="[item.bgColor == '#34C759' ? 'lv' : '', item.bgColor == '#6236FF' ? 'zs' : '', item.bgColor == '#FF9F19' ? 'hs' : '', item.bgColor == '#0A84FF' ? 'mm' : '']"
          >
          </el-progress>
        </div>
        <div class="zhb-num">
          <span class="compare">
            同比: {{ item.yoY }}% 
          </span>
          <span class="compare">
            环比: {{ item.qoQ }}% 
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dataCard',
  props: ['dataCore'],
  data() {
    return {
      imgs: [''],
      dataCoreCopy: []
    }
  },
  mounted() {
    console.log(this.dataCore)
  }
}
</script>
<style lang="scss">
.box-card-progress {
  width: 75%;

  &.box-card-progress-y {
    width: 70%;
    height: 50px;
    transform: scale(0.6);
    margin-left: -30px;
  }

  .el-progress__text {
    display: none !important;
  }

  .chart-bom-bom-pro1 {
    &.lv {
      .el-progress-bar__inner {
        background: #34c759 !important;
      }
    }

    &.hs {
      .el-progress-bar__inner {
        background: #ff9f19 !important;
      }
    }

    &.zs {
      .el-progress-bar__inner {
        background: #6236ff !important;
      }
    }
    &.mm {
      .el-progress-bar__inner {
        background: #0a84ff !important;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.box-card {
  margin-top: 10px;
}

.box-card-list,
.box-card-list-l {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // justify-content: flex-start;
  width: 100%;

  &.box-card-list-l {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    .box-card-item {
      border: 4px;
      margin-right: 10px;
      &:nth-child(6) {
        margin-right: 0px;
      }
      &:nth-child(-n + 6) {
        margin-bottom: 10px;
      }
    }
  }

  .box-card-item {
    display: flex;
    flex-direction: column;
    width: 15%;
    height: 110px;
    background: #ffffff;
    padding-left: 10px;
    padding-top: 10px;
    box-shadow: 0px 7px 25px 0px #e6edff;

    .box-card-item-num {
      display: flex;
      align-items: center;

      .box-card-icon {
        width: 20px;
        height: 20px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .zhb-num {
      display: flex;

      span {
        &:nth-child(2) {
          margin-left: 10px;
        }

        &.compare {
          display: inline-flex;
          align-items: center;
          flex-wrap: nowrap;
          font-size: 12px;
          white-space: nowrap;
        }
      }
    }

    .box-card-item-title {
      font-size: 14px;
      color: #74798c;
    }

    .box-card-item-max {
      font-size: 20px;
      font-weight: bold;
      margin-left: 10px;
    }

    span {
      margin: 3px 0;
      font-size: 14px;
    }
  }
}
</style>
